// Permission names as the backend sends them in /users/me (`permissions`, per org).
// The server decides who holds each one; the UI only checks for them.
const USER_PERMISSIONS = {
  ALL: 'All',
  READ_ORG: 'CanReadOrg',
  UPDATE_ORG: 'CanUpdateOrg',
  DELETE_ORG: 'CanDeleteOrg',
  GET_ORG_USERS: 'CanGetOrgUsers',
  UPDATE_USER: 'CanUpdateUser',
  REMOVE_USER: 'CanRemoveUser',
  INVITE: 'CanInvite',
  UPDATE_INVITATION: 'CanUpdateInvitation',
  DELETE_INVITATION: 'CanDeleteInvitation',
  LINK_YOUTUBE_ACCOUNT: 'CanLinkYouTubeAccount',
  MANAGE_SOCIAL_ACCOUNTS: 'CanManageSocialAccounts',
  DO_BILLING: 'CanDoBilling',
  READ_CMS: 'CanReadCms',
  SETUP_CMS: 'CanSetupCms',
  CREATE_TEAM: 'CanCreateTeam',
  UPDATE_TEAM: 'CanUpdateTeam',
  DELETE_TEAM: 'CanDeleteTeam',
  READ_TEAM: 'CanReadTeam',
  CREATE_EVENT: 'CanCreateEvent',
  UPDATE_EVENT: 'CanUpdateEvent',
  DELETE_EVENT: 'CanDeleteEvent',
  READ_EVENT: 'CanReadEvent',
  UPLOAD_MEDIA: 'CanUploadMedia',
  GET_GAME_SUMMARY: 'CanGetGameSummary',
  UPDATE_CHANNEL: 'CanUpdateChannel',
  POST_SOCIAL: 'CanPostSocial',
  DOWNLOAD_OVERLAY_LINKS: 'CanDownloadOverlayLinks',
}

export default USER_PERMISSIONS
